import React from "react";

const ChainOfCustodyContext = React.createContext();

export default ChainOfCustodyContext;